<template>
  <div class="auth-card__header">
    <span class="auth-card__icon">
      <component :is="icon" :size="24" :stroke-width="2.2" aria-hidden="true" />
    </span>

    <div class="auth-card__heading">
      <h2 class="auth-card__title">{{ title }}</h2>

      <p v-if="subtitle" class="auth-card__subtitle">{{ subtitle }}</p>
    </div>

    <div v-if="$slots.default" class="auth-card__header-extra"><slot /></div>
  </div>
</template>

<script setup lang="ts">
import type { Component } from "vue";

withDefaults(
  defineProps<{
    icon: Component;
    title: string;
    subtitle?: string;
  }>(),
  {
    subtitle: undefined,
  },
);
</script>
